import { GoogleOAuthProvider } from "@react-oauth/google";
import RegisterRoute from "../routes/RegisterRoute";

export default function SignupPage() {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const googleEnabled = Boolean(googleClientId);

  return (

    <div className="min-h-screen bg-[var(--color-grey)] dark:bg-[var(--color-darkmode)]">
        <RegisterRoute googleEnabled={googleEnabled} />

    </div>

  );
}
